<template>
    <FormRoot v-if="taskId || bulk">
        <Field
            :form.sync="form"
            type="component"
            component="Users"
            name="agent_id"
            placeholder="Agent"
            :searchFunction="fetchAgents"
            :hint="agentHint"
        />

        <FormActions>
            <Submit class="float-right" :disabled="!form.submittable" :loading="form.loading" @click="onSubmit"
                >Assign agent</Submit
            >
        </FormActions>
    </FormRoot>
</template>

<script>
    import { FormRoot, Field, FormActions, Submit } from '@tech_hexeko/design-system'
    import Forms from '@/mixins/Forms'
    import Tasks from '@/mixins/Tasks'

    export default {
        mixins: [Forms, Tasks],
        components: {
            FormRoot,
            FormActions,
            Submit,
            Field,
        },
        props: {
            bulk: {
                type: Boolean,
                default: false,
            },
            taskId: {
                type: String,
                default: '',
            },
        },
        data() {
            return {
                /** @public - used by Forms mixin */
                fields: {
                    agent_id: null,
                },
                /** @public - used by Forms mixin */
                messageSuccess: 'An agent has been assigned to the task',
            }
        },
        computed: {
            agentHint() {
                return this.bulk ? 'Select an agent to assign to those tasks' : 'Select an agent to assign to the task'
            },
        },
        methods: {
            fetchAgents(search) {
                return this.$api.users.get({ permission: this.taskPermission, search })
            },
            /** @public - used by Forms mixin */
            submit() {
                return this.$api.agents.assign(this.form.agent_id, {
                    payable_type: this.taskType,
                    payable_id: this.taskId,
                })
            },
        },
    }
</script>
